import React, { useEffect, useState } from "react";
import Edit from "../../Assets/img/Edit.svg";
import { useNavigate } from "react-router-dom";
import "../Eligibility/Eligibility.css";
import Search from "../../Assets/img/search.png";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";

const Eligibility = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [eligibility, setEligibility] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);

    const redirectMap = {
        "banner": "eligibilitybanneredit",
        "bannière": "eligibilitybanneredit",

        "check eligibility": "eligibilityedit",
        "vérifier l'éligibilité": "eligibilityedit",
    };


    const normalize = (str) =>
        str.replace(/\s+/g, " ").trim().toLowerCase();


    const fetchEligibility = () => {
        setLoading(true);

        let payload = { search, status, language_id: languageId, };

        API.post("eligibility_list/condition", payload)
            .then((response) => {
                const list = response?.data?.data?.data || [];

                const updatedList = list.map((item) => {
                    const key = normalize(item.heading);
                    return {
                        ...item,
                        redirect: redirectMap[key] || "",
                        eligibility_id: item.eligibility_id

                    };
                });

                setEligibility(updatedList);
            })
            .catch((err) => {
                console.error("Error:", err);
                setEligibility([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchEligibility();
    }, []);


    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        setLoading(true);

        API.post("eligibility_status/update", {
            eligibility_id: id,
            status: newStatus,
        })
            .then(() => fetchEligibility())
            .catch((err) => console.error("Failed to update status:", err))
            .finally(() => setLoading(false));
    };
    const filteredEligibility = eligibility.filter((item) => item.heading);

    return (
        <div className="services-container1">

            {/* HEADER */}
            <div className="services-header1">
                <h2 className="services-title1">Eligibility</h2>
            </div>

            {/* FILTER SECTION */}
            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search Eligibility..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div
                    className="filter-btn-wrapper"
                    onClick={() => fetchEligibility()}
                >
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    {/* OTHER SERVICES */}
                    <div className="services-grid3">
                        {filteredEligibility.length > 0 ? (
                            filteredEligibility.map((item) => (
                                <div className="services-card1" key={item.eligibility_id}>
                                    <p>{item.heading}</p>

                                    <div className="card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(
                                                            item.eligibility_id,
                                                            item.status
                                                        )
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() => {
                                                    if (item.redirect === "eligibilityedit") {
                                                        navigate(
                                                            `/eligibilityedit/${item.eligibility_id}?lang=${languageId}`
                                                        );
                                                        return;
                                                    }

                                                    navigate(`/${item.redirect}`);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-news-text">No Eligibility found.</p>
                        )}
                    </div>

                </>
            )}
        </div>
    );
};

export default Eligibility;
